/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Linesheet_Not_Ready_For_ApprovalInputs */

const en_error_linesheet_not_ready_for_approval = /** @type {(inputs: Error_Linesheet_Not_Ready_For_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The linesheet is missing data required for approval.`)
};

/**
* | output |
* | --- |
* | "The linesheet is missing data required for approval." |
*
* @param {Error_Linesheet_Not_Ready_For_ApprovalInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_linesheet_not_ready_for_approval = /** @type {((inputs?: Error_Linesheet_Not_Ready_For_ApprovalInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Linesheet_Not_Ready_For_ApprovalInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_linesheet_not_ready_for_approval(inputs)
});